module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.nome.$error
    }
  }, [_c('label', [_vm._v("Consulta*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.nome),
      expression: "model.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Telefone")]), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": "(11) 11111-1111"
    },
    model: {
      value: (_vm.model.telefone),
      callback: function($$v) {
        _vm.$set(_vm.model, "telefone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "model.telefone"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'has-danger': _vm.$v.model.data.$error
    }
  }, [_c('label', [_vm._v("Data*")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.config,
      "placeholder": "Selecione",
      "name": "date"
    },
    model: {
      value: (_vm.model.data),
      callback: function($$v) {
        _vm.$set(_vm.model, "data", $$v)
      },
      expression: "model.data"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Veterinário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.veterinario),
      expression: "model.veterinario"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.veterinario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "veterinario", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("CRMV/CBCK")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.numeroInscricao),
      expression: "model.numeroInscricao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "5"
    },
    domProps: {
      "value": (_vm.model.numeroInscricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "numeroInscricao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 align-self-center"
  }, [_c('label', [_vm._v("Realizada?*")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-toggle', {
    attrs: {
      "value": _vm.model.realizado
    },
    model: {
      value: (_vm.model.realizado),
      callback: function($$v) {
        _vm.$set(_vm.model, "realizado", $$v)
      },
      expression: "model.realizado"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Observação")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.observacao),
      expression: "model.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "cols": "50",
      "type": "text",
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.model.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "observacao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-danger': _vm.$v.model.preco.$error
    }
  }, [_c('label', [_vm._v("Preço R$*")]), _vm._v(" "), _c('money', {
    staticClass: "form-control",
    model: {
      value: (_vm.model.preco),
      callback: function($$v) {
        _vm.$set(_vm.model, "preco", $$v)
      },
      expression: "model.preco"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-consultation-pet',
        params: {
          id: this.$route.params.id
        }
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fas fa-notes-medical"
  }), _vm._v(" Consulta\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3424025c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pets/consultation/Form.vue
// module id = 848
// module chunks = 1